import { createAction } from '@reduxjs/toolkit';

import { Boat } from '../types';

export const setBoats = createAction<Boat[]>('SET_USER_BOATS');

export const BoatsActions = {
  setBoats,
};
